import React, { useState, useEffect, Fragment } from "react";
import { Row, Col } from "../../../UI/Customstrap/Customstrap";
import { Table, Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import { useSelector } from "react-redux";

import { FormattedNumber } from "../../../FormattedNumber/FormattedNumber";
import { FEATURE, isActionAllowed, showToast } from "../../../../utils/helper";
import {
  getSession,
  getCurrentAccount,
  getSavedPersonInfo,
  getPortfolio,
} from "../../../../reducers/selectors";

import style from "./FundsAssetTable.scss";
import { FundInvestModal } from "../FundInvestModal/FundInvestModal";
import { fetchGetPortfolio, getClientPositionDigital } from "../../../../services/api/accounts";

export const modes = {
  BUY: "BUY",
  SELL: "SELL",
};

export const FundsAssetTable = ({ funds }) => {
  const [modal, setModal] = useState({ open: false, mode: modes.BUY, fund: {} });
  const [portfolio, setPortfolio] = useState(null);
  const [portfolioDate, setPortfolioDate] = useState(new Date().toISOString().slice(0, 10));
  const currentAccount = useSelector(getCurrentAccount);
  const [loadingPosition, setLoadingPosition] = useState(true);

  useEffect(() => {
    if (!loadingPosition) setLoadingPosition(() => true);
    if (currentAccount.AccountNumber) {
      fetchGetPortfolio(currentAccount.AccountNumber, portfolioDate)
        .then(({ response }) => {
          setPortfolio(response);
          setPortfolioTotal(+response.position.valueTotalUSD + +response.positionPYG.valueTotalUSD);
          setFx(response.currencypairprice.rawprice);
        })
        .catch((err) => console.error(err))
        .finally(() => setLoadingPosition(false));
    }
    if (currentAccount.noAccounts) {
      setLoadingPosition(false);
    }
  }, [currentAccount, portfolioDate]);

  const handleChangeDate = (date) => {
    setPortfolioDate(() => date);
  };

  const handleDeposit = (fund) => {
    setModal(() => ({ open: true, mode: modes.BUY, fund }));
  };

  const handleWithdraw = (fund) => {
    setModal(() => ({ open: true, mode: modes.SELL, fund }));
  };

  const closeModal = () => {
    setModal(() => ({ open: false, mode: modes.BUY, fund: {} }));
  };

  return (
    <Fragment>
      {funds.map((fund, index) => {
        const item = fund.AssetInformation;
        item.availableBalance = 0;
        if (portfolio) {
          const { position, positionPYG } = portfolio;
          const currentPosition = item.CurrencyISO == "USD" ? position : positionPYG;
          if (currentPosition.assetClass.length > 0) {
            currentPosition.assetClass.map((assetClass) => {
              assetClass.subAssetClass.map((subAssetClass) => {
                subAssetClass.asset.map((asset) => {
                  if (+asset.id === +item.AssetId) {
                    item.availableBalance = asset.valuetotal;
                    item.AssetXIRR = asset.FundAnnualVariation;
                    item.AssetTargetPerformance = asset.TargetPerformance;
                  }
                });
              });
            })[0];
          }

          fund.AssetInformation = item;
        }
        return (
          <div className={style.offerCard}>
            <Col xs={12} lg={4} className={style.offerInfo}>
              <span className={`${style.offerField} ${style.name}`}>{item.AssetName}</span>
              <span className={`${style.offerField} ${style.nominal}`}>
                <span className={style.label}>Saldo Actual: </span>
                <FormattedNumber
                  value={item.availableBalance}
                  minimumFractionDigits={item.CurrencyISO == "USD" ? 2 : 0}
                  maximumFractionDigits={item.CurrencyISO == "USD" ? 2 : 0}
                />
              </span>
              <span className={style.offerField}>
                <span className={style.label}>Moneda: </span>
                {item.CurrencyISO}
              </span>
              {/* <span className={style.offerField}>
                <span className={style.label}>Rendimiento del año: </span>
                <FormattedNumber value={item.AssetXIRR} minimumFractionDigits={2} maximumFractionDigits={2} />
              </span> */}
              {item.AssetAnnualTargetPerformance && item.AssetAnnualTargetPerformance != 0 && (
                <span className={style.offerField}>
                  <span className={style.label}>Rendimiento Objetivo Anual: </span>
                  <FormattedNumber
                    value={item.AssetAnnualTargetPerformance}
                    minimumFractionDigits={2}
                    maximumFractionDigits={2}
                  />
                  <span className={style.label}> %</span>
                </span>
              )}
            </Col>
            <Col xs={12} lg={5} className={`${style.offerInfo} ${style.secondCol}`}></Col>
            <Col xs={12} lg={3} className={`${style.offerInfo} ${style.thirdCol}`}>
              {isActionAllowed(FEATURE.INVEST, currentAccount) && (
                <Fragment>
                  <Button className={style.button} onClick={() => handleDeposit(fund)}>
                    Suscribir
                  </Button>

                  <Button className={style.secondButton} onClick={() => handleWithdraw(fund)}>
                    Rescatar
                  </Button>
                </Fragment>
              )}
            </Col>
          </div>
        );
      })}
      {modal.open && (
        <FundInvestModal isOpen={modal.open} toggle={closeModal} fund={modal.fund} mode={modal.mode} />
      )}
    </Fragment>
  );
};
